import React from 'react';
import ErrorBoundaryPage from './ErrorBoundaryPage';

type ErrorInfo = {
  componentStack: string;
};

type Props = {
  children: React.ReactNode;
};

type State = {
  error?: Error;
  hasError: boolean;
};

class AppErrorBoundary extends React.Component<Props, State> {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error: Error) {
    return { hasError: true };
  }

  componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    this.setState({ error });
    console.error('error', error);
    console.error('errorInfo', errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return <ErrorBoundaryPage />;
    }
    return this.props.children;
  }
}

export default AppErrorBoundary;
